import { Link, MemoryRouter, Route, Routes, useLocation } from 'react-router';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "react-router": { Link, MemoryRouter, Route, Routes, useLocation }, "@mui/material/Pagination": Pagination, "@mui/material/PaginationItem": PaginationItem } } });
export default ClientProvider;
